import React, { useState } from "react";
import { Box, Typography, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Drawer from "@mui/material/Drawer";
import EditDialog from "./EditDialog";
import { post, put } from "../../utils/api";
import SelectField from "../Masters/SelectField";
import useYearOptions from "./YearOptions";

function Add({
  title,
  addData,
  id,
  setsnackOpen,
  handleClose,
  addUrl,
  updateUrl,
  fetchData,
  data
}) {
  const [errors, setErrors] = useState({});
  const currentDate = new Date();
  const year = new Date().getFullYear();
  const month = currentDate.getMonth() + 1;
  const initialState = {
    period:"",
    year: "",
  };
  const [formData, setFormData] = useState(initialState);
  const [formData2, setFormData2] = useState(initialState);
  const [editDialog, setEditDialog] = useState(false);
  const [yearOptions, setYearOptions] = useState([]);

  React.useEffect(() => {
    const currentYear = new Date().getFullYear();
    let options = [];
    if (formData.period === "Fiscal Year") {
      // Fiscal Year: e.g., 2022-2023, 2023-2024
      options = [
        `${currentYear - 1}-${currentYear}`,
        `${currentYear}-${currentYear + 1}`,
      ];
    } else if (formData.period === "Calendar Year") {
      // Calendar Year: e.g., 2022, 2023
      options = [
        `${currentYear - 1}`,
        `${currentYear}`,
      ];
    }
    setYearOptions(options);
    // Reset year if period changes
    setFormData((prev) => ({ ...prev, year: "" }));
  }, [formData.period]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setErrors((prev) => ({ ...prev, [name]: "",year:name==="period" && "" }));
    if (name === "year" && value?.startsWith("Fiscal") && month <= 3) {
      setErrors((prev) => ({
        ...prev,
        [name]:
          "You can not add BRSR report for fiscal year before April month",
      }));
      return;
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (formData?.period === "") newErrors["period"] = "Reporting Period is required";
    if (formData?.year === "") newErrors["year"] = "Reporting Year is required";
    const isExist=data?.find(el=>el?.year===formData?.year)
    console.log(isExist,"isExist")
    if(isExist)
      newErrors["year"] = "Entry for the selected Year already exists";
    setErrors(newErrors);
    console.log(newErrors, "new1");
    return Object.keys(newErrors).length === 0;
  };

  const [loading, setLoading] = useState(false); // State to track loading

  const Save = async () => {
    console.log(validateForm(), "new1");
    if (!validateForm()) return;

    // const method = id ? put : post;

    // const url = id ? `${updateUrl}?Id=${id}` : addUrl;
    // console.log(method, url, "new1");
    await post(addUrl, formData)
      .then((res) => {
        // console.log(method, url, "new1");

        setsnackOpen({
          open: true,
          message: res?.data?.message,
          severity: "success",
        });
        setFormData(initialState);
        fetchData();
        handleClose();
      })
      .catch((error) => {
        console.error("Save Error:", error);
      });
  };

  const handleExitAgree = () => {
    setErrors({});
    setEditDialog(false);
    setFormData(initialState);
    setFormData2(initialState); // Reset form data to initial state
    handleClose();
  };

  const handleExit = () => {
    const isFormDataUnchanged = Object.keys(formData).every(
      (key) => formData[key] === formData2[key]
    );
    if (isFormDataUnchanged) {
      handleExitAgree();
    } else {
      setEditDialog(true); // Show the EditDialog if there are changes
    }
  };

  const list = () => (
    <Box
      display="flex"
      gap={3}
      sx={{ width: "26rem", maxWidth: "100%", height: "100%" }}
    >
      {editDialog && (
        <EditDialog {...{ editDialog, setEditDialog, handleExitAgree }} />
      )}
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "20px",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton onClick={handleExit} sx={{ color: "black" }}>
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box sx={{ width: "88%", p: 3, backgroundColor: "#fff" }}>
        <Typography
          variant="h6"
          sx={{ textDecoration: "underline", fontWeight: "bold", mb: 2 }}
        >
          {/* {id ? "Add" + title + "" : "Edit" + title} */}
          Add {title}
        </Typography>
        <Box>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: "bold", mb: "-0.5rem" }}
          >
            Reporting Period
          </Typography>
          <SelectField
            name={"period"}
            value={formData?.period}
            handleChange={handleChange}
            label="Reporting Period"
            field="period"
            errors={errors?.["period"] || ""}
            defaultValue={"Select"}
            options={["Fiscal Year","Calendar Year"]} // Month options as strings
          />
        </Box>
        <Box>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: "bold", mb: "-0.5rem" }}
          >
           Reporting Year
          </Typography>
          <SelectField
            name={"year"}
            value={formData?.year}
            handleChange={handleChange}
            label="Reporting Period"
            field="year"
            errors={errors?.["year"] || ""}
            defaultValue={"Select"}
            options={yearOptions} // Now dynamic
          />
        </Box>

        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#0a3f73",
              textTransform: "none",
              marginTop: "10%",
            }}
            onClick={Save}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Box>
  );

  return (
    <Drawer
      sx={{
        backgroundColor: "transparent",
        "& .MuiDrawer-paper": {
          backgroundColor: "transparent",
          boxShadow: "none",
          height: "100%",
          minHeight: "100%",
          overflowY: "auto",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
        },
      }}
      anchor="right"
      open={addData}
      onClose={handleExit}
    >
      {list()}
    </Drawer>
  );
}

export default Add;
